var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isRouterAlive)?_c('div',{attrs:{"id":"app"}},[(!(_vm.name === '404' || _vm.name === 'login'  || _vm.name === 'Home'))?_c('ComHeaderOne'):_vm._e(),_c('router-view',{style:({ minHeight: _vm.Height + 'px' })})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }